import { ColDef, GetQuickFilterTextParams, ProcessCellForExportParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

import {
  formatCurrency as sharedCurrency,
  formatDate as sharedFormatDate,
  formatPercentage as sharedPercentage,
} from "~/shared/utils/formatters";

export const getQuickFilterFormatter = (columns: ColDef[]) => {
  const quickFilterColumns: ColDef[] = columns.map(col => {
    const quickFilter: ColDef = {
      getQuickFilterText: (params: GetQuickFilterTextParams) => {
        if (typeof params?.value === "object") {
          return "";
        }
        return (params?.value as string) || "";
      },
    };
    return { ...col, ...quickFilter };
  });
  return quickFilterColumns;
};

export const formatCurrency = sharedCurrency;
export const formatPercentage = sharedPercentage;

export function convertISODateToDateObject(isoDateString: string): Date | null {
  if (!isoDateString) {
    return null;
  }
  const d = new Date(isoDateString);
  return isNaN(d.getTime()) ? null : new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function fDate(date: string, _newFormat?: string) {
  return sharedFormatDate(date, "America/New_York", "medium");
}

export function fDateTime(date: string, _newFormat?: string) {
  return sharedFormatDate(date, "America/New_York", "long");
}

export const exportDataAsCsvCb = (gridRef: React.RefObject<AgGridReact>, exportFileName: string) => {
  gridRef?.current?.api?.exportDataAsCsv({
    fileName: exportFileName + "_" + getFormattedDate(new Date()),
    onlySelected: false,
    processCellCallback: function (params: ProcessCellForExportParams) {
      return findTextFromGridCell(params);
    },
  });
};

export const findTextFromGridCell = (params: ProcessCellForExportParams) => {
  if (params?.column?.getColDef()?.filter === "agDateColumnFilter") {
    return fDate(params?.value as string);
  }
  if (typeof params?.value === "number") {
    return String(params.value);
  }
  return (params?.value as string) ?? "";
};

const getFormattedDate = (date: Date): string => {
  const options: Intl.DateTimeFormatOptions = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };
  const dateString = date.toLocaleString("en-US", options);
  const formattedDate = dateString.replace(/\//g, "-").replace(/, /, " ").replace(/:/g, "_");
  return formattedDate;
};
